import dynamic from 'next/dynamic'

export const DynamicUniversalSearchFilterModal = dynamic(
  () => import('.').then((mod) => mod.UniversalSearchFilterModal),
  { ssr: false },
)
